var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-header',{staticClass:"paths-header",attrs:{"title":"Paths","show-banner":true},scopedSlots:_vm._u([{key:"actions",fn:function(){return [_c('pendo-button',{attrs:{"theme":"app","type":"primary","prefix-icon":"plus","label":"Create Path"},on:{"click":_vm.onCreatePathClick}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }